import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material';
import { Warning } from '@mui/icons-material';

export default function ForceCheckModal({ open, onClose, onConfirm, deviceId, deviceInfo, isAll = false, deviceCount = 0 }) {
  const deviceDisplayName = (deviceInfo?.deviceLabel || '').trim() || 'Totem';
  const deviceDisplaySecondary = (deviceInfo?.setupCode || '').trim() || deviceId;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="warning" />
        {isAll ? 'Force Update Check — Tutti i dispositivi' : `Force Update Check — ${deviceDisplayName}`}
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ py: 1 }}>
          {isAll ? (
            <>
              <Typography variant="body1" gutterBottom>
                Stai per forzare l'aggiornamento immediato di <strong>TUTTI</strong> i dispositivi online.
              </Typography>
              
              <Alert severity="error" sx={{ mt: 2 }} icon={false}>
                <Typography variant="subtitle2" gutterBottom>
                  ATTENZIONE MASSIMA
                </Typography>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                  <li>Bypass rollout: <strong>SÌ</strong> (tutti)</li>
                  <li>Bypass finestra manutenzione: <strong>SÌ</strong> (tutti)</li>
                </ul>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  TUTTI i dispositivi online scaricheranno e installeranno l'aggiornamento 
                  <strong> IMMEDIATAMENTE</strong>, anche fuori dalla finestra di manutenzione.
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                  Usare SOLO in emergenze critiche (es: vulnerabilità di sicurezza).
                </Typography>
              </Alert>
              
              <Box sx={{ mt: 2, p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  Dispositivi online: <strong>{deviceCount}</strong>
                </Typography>
                {deviceInfo && (
                  <Typography variant="body2" color="text.secondary">
                    Versione target: <strong>{deviceInfo.targetVersionName}</strong>
                  </Typography>
                )}
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body1" gutterBottom>
                Stai per forzare l'aggiornamento immediato di questo dispositivo.
              </Typography>
              
              <Alert severity="warning" sx={{ mt: 2 }} icon={false}>
                <Typography variant="subtitle2" gutterBottom>
                  ATTENZIONE
                </Typography>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                  <li>Bypass rollout: <strong>SÌ</strong></li>
                  <li>Bypass finestra manutenzione: <strong>SÌ</strong></li>
                </ul>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Il dispositivo scaricherà e installerà l'aggiornamento <strong>IMMEDIATAMENTE</strong>, 
                  anche se non è nella finestra di manutenzione.
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                  Usare solo in caso di emergenza.
                </Typography>
              </Alert>
              
              {deviceInfo && (
                <Box sx={{ mt: 2, p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Dispositivo: <strong>{deviceDisplayName}</strong>
                  </Typography>
                  {deviceDisplaySecondary ? (
                    <Typography variant="body2" color="text.secondary">
                      Setup code: <strong>{deviceDisplaySecondary}</strong>
                    </Typography>
                  ) : null}
                  <Typography variant="body2" color="text.secondary">
                    Versione attuale: <strong>{deviceInfo.currentVersionName} ({deviceInfo.currentVersion})</strong>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Versione target: <strong>{deviceInfo.targetVersionName} ({deviceInfo.targetVersion})</strong>
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
        >
          Annulla
        </Button>
        <Button 
          onClick={() => {
            onConfirm();
            onClose();
          }}
          variant="contained"
          color={isAll ? "error" : "warning"}
        >
          {isAll ? 'Conferma force check (tutti)' : 'Conferma force check'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
